import React from "react";

import ToggleSwitch from "@/components/Atoms/ToggleSwitch";

import {
  Info,
  Content,
  InfoIcon,
  InfoText,
  StyledGiftPackCard,
  Title,
} from "./style";

const GiftPackCard = ({ isGift, setIsGift }) => (
  <StyledGiftPackCard>
    <Content>
      <Title variant="paragraph2">
        Click if you are buying this for someone else.
      </Title>
      <Info>
        <InfoIcon icon="icon-info-circle-2" />
        <InfoText variant="paragraph4">
          Enter the details of the person who would be using the pack
        </InfoText>
      </Info>
    </Content>
    <ToggleSwitch
      value={isGift}
      onChange={(e) => setIsGift(e.target.checked)}
    />
  </StyledGiftPackCard>
);

export default GiftPackCard;
